import { createElement } from 'react';
import './index.scss';
const ColorfulText = function ColorfulInput({ color, style = {}, ...otherProps }) {
    const _style = style || {};
    if (color) {
        _style.backgroundColor = color;
    }
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    return (createElement("div", Object.assign({}, _otherProps),
        createElement("h2", null, "helloworld"),
        createElement("h5", null, "helloworld")));
};
export default ColorfulText;
